import { AccountTypeShortEnum } from 'applications/web/pages/UserSignup/Shared/helpers';
import useGetCurrentCustomerData from 'hooks/Authentication/useGetCurrentCustomerData';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { getReviewYears } from '../helpers';

const BackgroundSVG = ({ className }: { className?: string }) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 968 142"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    preserveAspectRatio="xMidYMid slice"
  >
    <rect width="968" height="142" fill="#8059C8" />
    <g
      style={{ mixBlendMode: 'hard-light' }}
      opacity="0.65"
      filter="url(#gradient_filter)"
    >
      <circle cx="674" cy="192" r="120" fill="#F59E0B" />
      <circle cx="264" cy="192" r="120" fill="#5AB7F9" />
      <circle cx="484" cy="42" r="120" fill="#ED6CAE" />
    </g>
    <defs>
      <filter
        id="gradient_filter"
        x="-56"
        y="-278"
        width="1050"
        height="820"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" />
        <feGaussianBlur stdDeviation="100" />
      </filter>
    </defs>
  </svg>
);

const WelcomeBanner: FC = () => {
  const { t } = useTranslation();

  const { year } = getReviewYears();

  const { data: user } = useGetCurrentCustomerData();
  const firstName = user?.firstName;

  return (
    <div className="text-center rounded-xl relative overflow-hidden">
      <BackgroundSVG className="absolute inset-0" />

      <div className="relative py-4">
        <h2 className="text-white text-4xl font-bold">
          {t('yearly_review.welcome_banner.title', {
            firstName,
            year,
          })}
        </h2>

        <p className="text-white text-lg">
          {user?.accountType === AccountTypeShortEnum.one_person_company
            ? t('yearly_review.welcome_banner.subtitle_corporate', { year })
            : t('yearly_review.welcome_banner.subtitle', { year })}
        </p>
      </div>
    </div>
  );
};

export default WelcomeBanner;
